import { useBreakpointValue } from '@chakra-ui/react';

import { isSmartphone } from '$/utils/userAgent';

export const useIsMobile = (
  {
    sm,
    forceSmartphoneIsMobile,
  }: { sm: boolean; forceSmartphoneIsMobile?: boolean } = { sm: false },
) => {
  const breakpointIsMobile = !!useBreakpointValue(
    { base: true, mobile: sm, sm: false },
    { ssr: false },
  );

  const isMobile =
    forceSmartphoneIsMobile === true ? isSmartphone() : breakpointIsMobile;

  return isMobile;
};
